module.exports = __webpack_public_path__ + "img/left-arrow.cc70a47a.png";